import { render, staticRenderFns } from "./GameAssets.vue?vue&type=template&id=1971e792&scoped=true"
import script from "./GameAssets.vue?vue&type=script&lang=js"
export * from "./GameAssets.vue?vue&type=script&lang=js"
import style0 from "./GameAssets.vue?vue&type=style&index=0&id=1971e792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1971e792",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage});
